var map = {
	"./banescale.png": 40,
	"./bogsneak.png": 41,
	"./coatl.png": 42,
	"./fae.png": 43,
	"./gaoler.png": 44,
	"./guardian.png": 45,
	"./imperial.png": 46,
	"./mirror.png": 47,
	"./nocturne.png": 48,
	"./obelisk.png": 49,
	"./pearlcatcher.png": 50,
	"./ridgeback.png": 51,
	"./skydancer.png": 52,
	"./snapper.png": 53,
	"./spiral.png": 54,
	"./tundra.png": 55,
	"./veilspun.png": 56,
	"./wildclaw.png": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;